import type { PrefetchContext } from 'src/shared/prefetch';

import { prefetchFcm } from './shared/fcm';

export async function prefetch(context: PrefetchContext): Promise<void> {
	await prefetchFcm(context);
}
